import { useContext, useMemo } from "react";
import { OrganizationContext } from "./OrganizationProvider";
import { Organization } from "../../../hooks/api-new";

export const useOrganization = () => useContext(OrganizationContext);

export const useCurrentPlan = (organization?: Organization) => {
  return useMemo(() => {
    if (!organization) {
      return;
    }

    if (organization.recording_enabled) {
      return "business";
    }

    if (organization.voice_avatar_enabled) {
      return "pro";
    }

    return "starter";
  }, [organization]);
};
